import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Container } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MapIcon from '@mui/icons-material/Map';

import IncidentDetail from '../components/incidents/IncidentDetail';

/**
 * Standalone page for one incident's full record (/…/incidents/:id/log).
 * The primary view is the same record as a modal over the project map
 * (/…/incidents/:id); this page exists for a full-window read and as a
 * fallback that needs no map.
 */
export default function IncidentLogPage() {
    const { projectId, incidentId } = useParams();
    const navigate = useNavigate();
    if (!projectId || !incidentId) return null;

    return (
        <Container
            maxWidth="xl"
            sx={{
                py: 3,
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                // Desktop: the page fits the viewport and panels scroll
                // internally. Small screens fall back to normal page flow.
                height: { xs: 'auto', lg: 'var(--vh100)' },
            }}
        >
            <Box sx={{ flexShrink: 0, display: 'flex', gap: 1, mb: 1.5 }}>
                <Button
                    startIcon={<MapIcon />}
                    onClick={() => navigate(`/projects/${projectId}/incidents/${incidentId}`)}
                >
                    Show on map
                </Button>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(`/projects/${projectId}`)}
                >
                    Back to project
                </Button>
            </Box>
            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <IncidentDetail
                    projectId={projectId}
                    incidentId={incidentId}
                    onSelectIncident={(id) => navigate(`/projects/${projectId}/incidents/${id}/log`)}
                />
            </Box>
        </Container>
    );
}
